// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC5LQQMqvqt0oHlsj5POY2szgF1ksoZNe4",
  authDomain: "suniel-portfolio.firebaseapp.com",
  projectId: "suniel-portfolio",
  storageBucket: "suniel-portfolio.appspot.com",
  messagingSenderId: "758333170737",
  appId: "1:758333170737:web:e3d24dcd47c57fb2f26110"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const db =  getFirestore();
